/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Level_Fuzzy_Lion_StriveInputs */

const fr_level_fuzzy_lion_strive = /** @type {(inputs: Level_Fuzzy_Lion_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une section`)
};

/**

* @param {Level_Fuzzy_Lion_StriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const level_fuzzy_lion_strive = /** @type {((inputs?: Level_Fuzzy_Lion_StriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Level_Fuzzy_Lion_StriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_level_fuzzy_lion_strive(inputs)
});